/**
 * SVG filter primitives that give the Aqua (liquid-glass) design real
 * optical refraction. These are referenced from CSS via
 * `backdrop-filter: ... url('#liquid-glass-refraction')`, so the content
 * seen *through* the glass is genuinely displaced and lensed — not faked
 * with gradients alone.
 *
 * Mounted once, only while the liquid-glass design is active. The element
 * is visually hidden but must remain in the DOM for the url() references to
 * resolve.
 */
function GlassFilters() {
  return (
    <svg
      className="glass-filter-defs"
      aria-hidden="true"
      focusable="false"
      width="0"
      height="0"
      style={{ position: 'absolute', width: 0, height: 0, pointerEvents: 'none' }}
    >
      <defs>
        {/* Edge-lens refraction: a soft turbulent displacement that ripples
            the backdrop, concentrated by a blur so the centre stays clear
            while the rim bends light like the curved edge of real glass. */}
        <filter
          id="liquid-glass-refraction"
          x="-40%"
          y="-40%"
          width="180%"
          height="180%"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.004 0.006"
            numOctaves="2"
            seed="14"
            result="turb"
          />
          <feGaussianBlur in="turb" stdDeviation="5" result="softTurb" />
          <feDisplacementMap
            in="SourceGraphic"
            in2="softTurb"
            scale="30"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>

        {/* A gentler variant for smaller controls (segmented buttons, pills),
            where heavy displacement would smear text behind them. */}
        <filter
          id="liquid-glass-refraction-soft"
          x="-35%"
          y="-35%"
          width="170%"
          height="170%"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.006 0.008"
            numOctaves="2"
            seed="9"
            result="turb"
          />
          <feGaussianBlur in="turb" stdDeviation="3.6" result="softTurb" />
          <feDisplacementMap
            in="SourceGraphic"
            in2="softTurb"
            scale="16"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default GlassFilters
